import { footerData } from '@/mocks/homeData';

export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="bg-background-100 rounded-xl p-6 md:p-10 border border-background-200/70 text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-5">
            <i className="ri-send-plane-line text-2xl md:text-3xl text-primary-500"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            {footerData.contactTitle}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto">
            {footerData.contactDesc}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#contact"
              onClick={(e) => e.preventDefault()}
              className="whitespace-nowrap cursor-pointer px-8 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-colors text-sm md:text-base"
            >
              立即投稿
            </a>
            <a
              href="#contact"
              onClick={(e) => e.preventDefault()}
              className="whitespace-nowrap cursor-pointer px-8 py-3 border border-foreground-200 text-foreground-700 font-medium rounded-md hover:bg-background-200 transition-colors text-sm md:text-base"
            >
              了解更多
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}